import React from 'react';
import FollowingSettingsPage from 'app/routes/settings/FollowingSettingsPage';
import AuthProtectedPage from 'app/routes/auth/AuthProtectedPage';
import {useSelector} from 'react-redux';
import {selectAuthState, selectFetchStates} from 'app/hooks/reduxCreateSelectorHooks';

const FollowSettingsWrapperPage = props => {
  const {followsFetched} = useSelector(selectFetchStates);
  const isAuthenticated = useSelector(selectAuthState);

  return isAuthenticated && followsFetched ? (
    <FollowingSettingsPage />
  ) : (
    <AuthProtectedPage loading={props.initializing || (isAuthenticated && !followsFetched)} />
  );
};

export default FollowSettingsWrapperPage;
